export default __webpack_public_path__ + "static/media/round-content-add-circle.35214e74.svg";